import { createContext } from 'react';
import { Subject } from 'rxjs';

const mock = () => {};
/**
 *
 * @type {InternalAPI}
 */
const actions = {
  getExtension: mock,
  hostApp: {
    createControl: mock,
    removeControl: mock,
    requestForeground: mock,
    releaseForeground: mock,
    message$: new Subject(),
  },
  mns: {
    publish: mock,
    subscribe: mock,
    unsubscribe: mock,
  },
  getObjectConfig: mock,
  interpolate: mock,
};

/**
 *
 * @type {React.Context<InternalAPI>}
 */
const actionContext = createContext(actions);

export default actionContext;
